export var CTA_TYPES = {
  APPLY_NOW: 'APPLY_NOW',
  READ_REVIEW: 'READ_REVIEW',
  PREQUAL: 'PREQUAL'
};
export var PHONE_NUMBER_SUBTEXT = 'or call ';